exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mx-loader{display:none;position:fixed;z-index:9999;width:100%;height:100%;left:0;top:0;background:hsla(0,0%,100%,.5)}.mx-loader:after{content:\"\";display:block;z-index:9999;position:absolute;margin:auto;top:0;right:0;bottom:0;left:0;background:url(" + require("../img/jquery.loader.gif") + ") no-repeat 50%;width:64px;height:64px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/css-loader!./plugins/jquery.loader/css/jquery.loader.css
// module id = 159
// module chunks = 2 3 7 8 11 21 22 23 40 41 43 44 45 47 48 49 51